import React from 'react';

import {Tooltip} from '@optimaxdev/design-system';
import {Link} from 'react-router-dom';

import {PRESCRIPTION_METHOD} from 'constants/product';

import {PrescriptionType} from '../../store/fixtures/prescriptionFixture';

import {VistaPlusInfoRow} from '../vistaPlusInfoRow/vistaPlusInfoRow';
import {VistaPlusPrescriptionTable} from '../vistaPlusPrescriptionTable/vistaPlusPrescriptionTable';

import s from './VistaPlusPrescription.scss';

export type PropsType = {
    prescription: PrescriptionType;
    lensType?: string;
    contactLensPerBox: string;
    boxCount: string | number;
};

/**
 * Get the prescription link button
 * @param {PrescriptionType} prescription - prescription
 * @returns {React.ReactElement | null} - prescription link element
 */
const getLinkToPrescription = (prescription: PrescriptionType): Maybe<React.ReactElement> => {
    const {
        link,
        method,
        od: {sph: odSph},
        os: {sph: osSph},
    } = prescription;

    switch (method) {
        case PRESCRIPTION_METHOD.UPLOAD_METHOD:
            return (
                <>
                    <Link className={s.link} rel="noopener noreferrer" target="_blank" to={link}>
                        View Prescription
                    </Link>
                </>
            );
        case PRESCRIPTION_METHOD.FILL_IT_ONLINE_METHOD:
            return (
                <>
                    <Tooltip
                        arrowColor="#dedede"
                        containerClassName={s.tooltip}
                        content={<VistaPlusPrescriptionTable odSph={odSph} osSph={osSph} />}
                        position="bottom"
                    >
                        <span className={s.link}>View Prescription</span>
                    </Tooltip>
                </>
            );
        default:
            return null;
    }
};

/**
 * Prescription section of the Vista Plus cart item
 * @param {PropsType} - props
 * @returns {React.ReactElement} - prescription section
 */
export const VistaPlusPrescription: React.FC<PropsType> = ({
    boxCount,
    contactLensPerBox,
    lensType,
    prescription,
}) => {
    const totalLenses = Number(contactLensPerBox) * Number(boxCount);
    const daysOfUse = totalLenses / 2;

    return (
        <>
            <VistaPlusInfoRow
                button={getLinkToPrescription(prescription)}
                className={s.infoRow}
                info={`${lensType} use, ${prescription.name}`}
                title="Lens Type:"
            />

            <VistaPlusInfoRow
                info={`${totalLenses} lenses, for ${daysOfUse} days`}
                title="Quantity:"
            />
        </>
    );
};
